import { useState, useEffect } from 'react';
import { useTheme } from 'next-themes';
import IconChatbot from '@/assets/images/icon-chatbot.gif';
import ChatbotDarkIcon from '@/assets/svg/chatbot-dark.svg';
import ChatbotLightIcon from '@/assets/svg/chatbot-light.svg';
import TitleIconDark from '@/assets/svg/title-icon-dark.svg';
import TitleIconLight from '@/assets/svg/title-icon-light.svg';
import ChatbotUI from '@/components/Helper/chatbot/ChatbotUI';

const ChatbotFloating = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';

  const iconSource = isDark ? ChatbotDarkIcon : ChatbotLightIcon;
  const iconTitle = isDark ? TitleIconDark : TitleIconLight;

  // Prevent body scroll on mobile when chatbot is open
  useEffect(() => {
    if (isOpen && window.innerWidth < 768) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  return (
    <div className="fixed bottom-4 right-4 z-[60]">
      {!isOpen && (
        <button
          type="button"
          aria-label="Open chatbot"
          className="flex items-center justify-center w-[5.6rem] h-[5.6rem] rounded-[1.8rem] md:w-[64px] md:h-[64px] lg:w-[72px] lg:h-[72px] transition-transform duration-200 ease-in-out hover:-translate-y-[1px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#57E8BA]"
          style={{
            background: `${
              isDark
                ? 'linear-gradient(180deg, rgba(43, 255, 255, 0.32) 0%, rgba(43, 255, 255, 0.1) 50%, rgba(43, 255, 255, 0.16) 100%)'
                : '#28BA8C'
            }`,
            border: '0.5px solid #57E8BA',
            boxShadow: '0px 0px 30px 0px #57E8BA4D',
          }}
          onClick={() => setIsOpen(true)}
        >
          <img src={IconChatbot} alt="Chatbot" />
        </button>
      )}

      {isOpen && (
        <div className="fixed inset-0 md:absolute md:bottom-[0.5rem] md:right-0 md:inset-auto pointer-events-auto z-50">
          <ChatbotUI
            chatbotIcon={iconSource}
            onClose={() => setIsOpen(false)}
            iconTitle={iconTitle}
          />
        </div>
      )}
    </div>
  );
};

export default ChatbotFloating;
